import React, { useState } from 'react';
import styled from 'styled-components/native';
import Button from '../../components/Button';
import Link from '../../components/Link';
import { StackNavigationProp } from '@react-navigation/stack';
import { useNavigation } from '@react-navigation/native';
import { Platform } from 'react-native';
import WebViewModal from '../modals/WebViewModal';
import accessibilityTags from '../../../accessibilityTags';

const StyledScrollView = styled.ScrollView`
  background-color: #fdfbf7;
  padding: 32px 23px 32px 23px;
  flex: 1;
`;

const StyledContainer = styled.View`
  flex: 1;
  width: 100%;
  align-self: center;
  max-width: 768px;
  margin-top: ${Platform.OS === 'web' ? 0 : 10}px;
`;
const StyledSubtitle = styled.Text`
  font-family: 'DMSans-Medium';
  font-size: 16px;
  line-height: 18px;
  color: #141027;
`;

const StyledButtonContainer = styled.View`
  position: absolute;
  bottom: 0;
  left: -10px;
  right: -10px;
`;

const StyledLink = styled(Link)`
  font-family: 'DMSans-Medium';
  font-size: 16px;
  line-height: 20px;
  color: blue;
`;

const MyProfileDataPrivacySettingsScreen: React.FC = () => {
  const navigation = useNavigation<StackNavigationProp<any>>();
  const [openUrl, setOpenUrl] = useState<{ title: string; url: string }>();
  return (
    <StyledScrollView contentContainerStyle={{ flexGrow: 1 }}>
      <StyledContainer>
        <StyledSubtitle>
          Our{' '}
          <StyledLink
            onPress={() => {
              const url = 'https://peoplescience.health/privacy-policy/';
              if (Platform.OS == 'web') {
                window.open(url, '_blank');
              } else {
                setOpenUrl({ title: 'Privacy Policy', url });
              }
            }}
          >
            Privacy Policy
          </StyledLink>{' '}
          states how we will collect, use, share, and protect your personal
          data. You may delete your data at any time.
        </StyledSubtitle>
        <StyledButtonContainer>
          <Button
            accessibilityLabel={accessibilityTags.deleteAccountButtonID}
            testID={accessibilityTags.deleteAccountButtonID}
            color='secondary'
            onPress={() => navigation.navigate('MyProfileDeleteData')}
          >
            Delete My Account
          </Button>
        </StyledButtonContainer>
      </StyledContainer>
      {!!openUrl && (
        <WebViewModal
          visible
          title={openUrl.title}
          url={openUrl.url}
          onClose={() => setOpenUrl(undefined)}
        />
      )}
    </StyledScrollView>
  );
};

export default MyProfileDataPrivacySettingsScreen;
